import React from "react";
import { Box } from "@mui/material";
import GVarLogo from "./GVarLogo";

/**
 * Branded loading indicator for the G-VaR pages — a pulsing (not spinning)
 * logo, since the logo's off-center wordmark doesn't read well rotated.
 */
export default function GVarLoader({ size = "22.5vw", sx = {} }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 8, ...sx }}>
      <GVarLogo
        sx={{
          width: size,
          height: "auto",
          animation: "gvar-loader-pulse 1.4s ease-in-out infinite",
          "@keyframes gvar-loader-pulse": {
            "0%, 100%": { opacity: 1 },
            "50%": { opacity: 0.35 },
          },
        }}
      />
    </Box>
  );
}
